module.exports = __webpack_public_path__ + "img/cotedivoire.717ba6f2.svg";